import { DatabaseIdGenerator, initBinaryBlobFactory, initDataModelFactory, UnknownDataModelTypePolicy } from 'in-time-core';
import { BinaryBlobConverter } from './core/utils/binary-blob-converter';
import { DiscoverCategory, DiscoverCategoryBuilder } from './pages/legacy-discover-page/data-models/discover-category';
import { DiscoverSnapshot, DiscoverSnapshotBuilder } from './pages/legacy-discover-page/data-models/discover-snapshot';
import { MyMekiEventData, MyMekiEventDataBuilder } from './core/models/my-meki-event-data';

export function initializeSerialization(options: { databaseIdGenerator: DatabaseIdGenerator }): void {
  const builders = new Map<string, unknown>();

  builders.set(DiscoverCategory.TYPE_ID, new DiscoverCategoryBuilder());
  builders.set(DiscoverSnapshot.TYPE_ID, new DiscoverSnapshotBuilder());
  builders.set(MyMekiEventData.TYPE_ID, new MyMekiEventDataBuilder());

  initDataModelFactory({
    customBuilders: builders,
    databaseIdGenerator: options.databaseIdGenerator,
    unknownTypePolicy: UnknownDataModelTypePolicy.Log,
  });

  initBinaryBlobFactory(new BinaryBlobConverter());
}